const emailValidator = (input: string | null = '', errorMessage: string): string | undefined => {
  const value = input?.trim();
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return value && emailPattern.test(value) ? undefined : errorMessage;
};

export { emailValidator };
